import _lib from '../_lib';
import active from './active/index';
import {DiagnosisNavigation} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  let regionName = 'diagnosis';
  let activations = [
    {
      name: 'diagnosis',
      test: api.messageIs(DiagnosisNavigation)
    }
  ];
  let activeIndex = active;
  let func = _lib({regionName,activations,activeIndex});
  return func({tree,parent,api});
};

